import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
// import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { VoucherFooterComponent } from "../common/components/voucher-footer/voucher-footer.component";
import { VoucherHeaderComponent } from "../common/components/voucher-header/voucher-header.component";
import { filter } from 'rxjs';
import { SessionTimeoutService } from '../services/session-timeout.service';
import { DialogModule } from 'primeng/dialog';
import { ThreeButtonDialogComponent } from '../common/components/threebuttondialog/three-button-dialog.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, VoucherHeaderComponent, VoucherFooterComponent, ConfirmDialogModule, CommonModule, NgxSpinnerModule, DialogModule,ThreeButtonDialogComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Walgreens - Immunize';
  showFooter = true;
  showSessionWarning = false;
  countdown = 30;

  constructor(private router: Router,
    private sessionTimeout: SessionTimeoutService,
    // private msalService: MsalService,
    // private msalBroadcastService: MsalBroadcastService,
    private ngx: NgxSpinnerService,
  ) {
    this.router.events.subscribe(() => {
      this.showFooter = !this.router.url.includes('login');
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

        if (sessionStorage.getItem('companyId')) {
          this.sessionTimeout.start();
        } else {
          this.sessionTimeout.stop();
        }
      });
  }

  ngOnInit(): void {

    this.sessionTimeout.showWarning$.subscribe(show => {
      this.showSessionWarning = show;
    });

    this.sessionTimeout.countdown$.subscribe(seconds => {
      this.countdown = seconds;
    });

    if (sessionStorage.getItem('companyId')) {
      this.sessionTimeout.start();
    }
    // this.msalService.handleRedirectObservable().subscribe();
    // this.msalBroadcastService.inProgress$
    //   .subscribe((status: InteractionStatus) => {

    //     if (status !== InteractionStatus.None) {
    //       this.ngx.show();
    //     } else {
    //       this.ngx.hide();
    //     }
    //   });
  }

  stayLoggedIn(): void {
    this.sessionTimeout.stayLoggedIn();
  }

  logoutFromIdlePopup(): void {
  this.sessionTimeout.logout();
}
}
